import React from 'react';
import QuickMenuComponent from './QuickMenu.component';
import { QuickMenuProps } from './QuickMenu.types';

/**
 * 에디터용 QuickMenu 컴포넌트
 * 에디터에서는 클릭 이벤트를 비활성화하고 편집 모드로 렌더링
 */
const QuickMenuEditor: React.FC<QuickMenuProps> = (props) => {
  // 에디터 모드에서는 항상 edit 모드로 전달
  const editorProps = {
    ...props,
    mode: 'edit' as const
  };
  
  return <QuickMenuComponent {...editorProps} />;
};

export default QuickMenuEditor;